<template>
  <button
    class="ml-2 bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2 rounded"
  >
    <slot>Search</slot>
  </button>
</template>
